
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
import SideBar from './SideBarGestionClient';

//import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function DocumentsAdministratifsClient() {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const { i18n } = useTranslation ();
    const navigate = useNavigate();

    const axiosPrivate = useAxiosPrivate();
    //const navigate = useNavigate();
    const [dataClient, setdataClient] = useState({});
    let param = useParams();
    const [name, setName] = useState('');
    const [statut, setStatut] = useState('');
    const [date, setDate] = useState('');
    const [heure, setHeure] = useState('');

    const getClientbyId = async () => {
        try {
            let endpoint = pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
            const response = await axiosPrivate.get(endpoint+(param.ClientId ?? param.EsnId));
            setdataClient(response.data);

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getClientbyId();
    }, []);

    const getInformationContrat = () => {
        dataClient?.docsAdministratifs?.map(obj=>{
            if(obj.titre=='Contrat')
            {
                setName(obj.url);
                setStatut(obj.statut);
                if (typeof obj.dataDynamique === 'string') {
                    setDate((obj.dataDynamique).substring(0,10));
                    setHeure((obj.dataDynamique).substring(12,16));
                }
            }
        });
    };

    //export default function formatDate(dateString) {
    //    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    //    return new Date(dateString).toLocaleDateString(undefined, options);
    //}
    //export function formatDateJJMMYYYY(dateString) {
    //    if (new Date(dateString)?.toLocaleDateString('en-GB') == 'Invalid Date')
    //        return '_______';
    //    return new Date(dateString)?.toLocaleDateString('en-GB');
    //}

    useEffect(()=>{
        getInformationContrat();
        console.log('dataClient',dataClient);
        console.log('statut',statut);
    }, [dataClient]);

    return (
        <>
            <p className='TitleCompteExpert'>{i18n.t('Compte')} &gt; {i18n.t('Données profil')}</p>
            <SideBar/>

            <div className='frame0CompteClient'>
                <div className='frame1CompteClient'>
                    {/*<div className='frame2CompteClient'>*/}
                    {/*<div className='frame3CompteClient'>*/}
                    <div
                        className='frame4CompteClient'
                        style={
                            currentPath == 'CompteClientDocAdministratifs' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            //className='titleNavBarCompteExpert'
                            style={
                                currentPath == 'CompteClientDocAdministratifs'  ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                if(currentPath == 'CompteClientDocAdministratifs')
                                    navigate('.');
                                else
                                    navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientDocAdministratifs', { replace: true });

                            }}
                        >{i18n.t('Kbis')}</p>
                    </div>

                    <div
                        className='frame5CompteClient'
                        style={
                            currentPath == 'CompteClientDocAdministratifsContrat' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                currentPath == 'CompteClientDocAdministratifsContrat' ? SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                navigate('.', { replace: true });

                            }}
                        >{i18n.t('Contrat')}</p>
                    </div>
                </div>

                <div className='frame12DocAdmini'>
                    <div className='frame13DocAdmini'>
                        <div className='frame14DocAdmini'>
                            <div className='frame15DocAdmini'>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_3794_59592)">
                                        <path
                                            d="M8.0625 12.25V14.5C8.0625 15.1328 8.55469 15.625 9.1875 15.625H14.8125C15.4102 15.625 15.9375 15.1328 15.9375 14.5V12.25C15.9375 11.6523 15.4102 11.125 14.8125 11.125H9.1875C8.55469 11.125 8.0625 11.6523 8.0625 12.25ZM18.082 6.55469L15.4453 3.91797C15.0234 3.49609 14.4609 3.25 13.8633 3.25H7.5C6.23438 3.25 5.25 4.26953 5.25 5.5V19C5.25 20.2656 6.23438 21.25 7.5 21.25H16.5C17.7305 21.25 18.75 20.2656 18.75 19V8.13672C18.75 7.53906 18.5039 6.97656 18.082 6.55469ZM17.0625 19C17.0625 19.3164 16.7812 19.5625 16.5 19.5625H7.5C7.18359 19.5625 6.9375 19.3164 6.9375 19V5.53516C6.9375 5.21875 7.18359 4.97266 7.5 4.97266H13.125V7.75C13.125 8.38281 13.6172 8.875 14.25 8.875H17.0273V19H17.0625ZM8.625 7.75H11.4375C11.7188 7.75 12 7.50391 12 7.1875C12 6.90625 11.7188 6.625 11.4375 6.625H8.625C8.30859 6.625 8.0625 6.90625 8.0625 7.1875C8.0625 7.50391 8.30859 7.75 8.625 7.75ZM8.625 10H11.4375C11.7188 10 12 9.75391 12 9.4375C12 9.15625 11.7188 8.875 11.4375 8.875H8.625C8.30859 8.875 8.0625 9.15625 8.0625 9.4375C8.0625 9.75391 8.30859 10 8.625 10ZM15.375 16.75H12.5625C12.2461 16.75 12 17.0312 12 17.3125C12 17.6289 12.2461 17.875 12.5625 17.875H15.375C15.6562 17.875 15.9375 17.6289 15.9375 17.3125C15.9375 17.0312 15.6562 16.75 15.375 16.75Z"
                                            fill="#272D3C"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_3794_59592">
                                            <rect
                                                width="24"
                                                height="24"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                            <h5 className='frame16DocAdmini'>
                                {i18n.t('Contrat')}
                            </h5>
                        </div>
                        <div className='frame17DocAdmini'>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    padding: '0px',
                                    width: '238px',
                                    height: '76px',
                                    flex: 'none',
                                    order: '0',
                                    flexGrow: '0',
                                }}
                            >
                                <div className='frame26DocAdmini'>

                                    <div className='frame19DocAdmini'>
                                        <svg
                                            width="19"
                                            height="25"
                                            viewBox="0 0 19 25"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M17.1927 4.65625L13.6771 1.14062C13.1146 0.578125 12.3646 0.25 11.5677 0.25H3.08337C1.39587 0.25 0.083374 1.60938 0.083374 3.25V21.25C0.083374 22.9375 1.39587 24.25 3.08337 24.25H15.0834C16.724 24.25 18.0834 22.9375 18.0834 21.25V6.76562C18.0834 5.96875 17.7552 5.21875 17.1927 4.65625ZM15.8334 21.25C15.8334 21.6719 15.4584 22 15.0834 22H3.08337C2.6615 22 2.33337 21.6719 2.33337 21.25V3.29688C2.33337 2.875 2.6615 2.54688 3.08337 2.54688H10.5834V6.25C10.5834 7.09375 11.2396 7.75 12.0834 7.75H15.7865V21.25H15.8334ZM9.55212 13.7031C9.55212 13.5625 9.599 13.4219 9.64587 13.2812C9.73962 13.0469 10.0209 11.8281 10.0209 10.8438C10.0209 9.95312 9.31775 9.25 8.42712 9.25C7.58337 9.25 6.88025 9.95312 6.88025 10.8438C6.88025 10.8438 6.88025 12.2031 7.48962 13.75C7.1615 14.6875 6.7865 15.5781 6.31775 16.4688C5.33337 16.9375 4.48962 17.5 3.83337 18.1562C3.55212 18.4844 3.4115 18.8594 3.4115 19.3281C3.4115 20.1719 4.11462 20.875 4.95837 20.875C5.474 20.875 5.94275 20.6406 6.27087 20.2188C6.599 19.75 7.11462 19 7.67712 17.9688C8.42712 17.6406 9.27087 17.4062 10.2084 17.2188C10.8177 17.6406 11.5677 18.0156 12.3646 18.25C12.5521 18.3438 12.7865 18.3906 13.0209 18.3906C13.9584 18.3906 14.7084 17.6406 14.7084 16.6562C14.7084 15.7188 13.9584 14.9219 12.974 14.9219H12.8334C12.6927 14.9219 11.849 14.9688 10.6771 15.1562C10.2084 14.7344 9.83337 14.2656 9.55212 13.7031ZM5.23962 19.5156C5.05212 19.75 4.67712 19.6562 4.67712 19.2812C4.67712 19.1875 4.67712 19.0938 4.724 19.0469C5.14587 18.625 5.6615 18.25 6.224 17.9219C5.80212 18.7188 5.42712 19.2344 5.23962 19.5156ZM8.42712 10.5156C8.61462 10.5156 8.75525 10.6562 8.75525 10.8438C8.75525 11.5469 8.56775 12.4844 8.474 12.8125C8.14587 11.7344 8.099 10.9375 8.099 10.8438C8.099 10.6562 8.23962 10.5156 8.42712 10.5156ZM7.67712 16.6094C7.95837 15.9531 8.2865 15.25 8.56775 14.5C8.89587 15.0156 9.27087 15.5312 9.73962 16C9.08337 16.1406 8.38025 16.3281 7.67712 16.6094ZM12.8334 16.1875H12.974C13.2552 16.1875 13.4427 16.375 13.4427 16.7031C13.4427 16.9375 13.2552 17.125 13.0209 17.125C12.9271 17.125 12.8334 17.125 12.7396 17.0781C12.1771 16.8906 11.6615 16.6562 11.2396 16.375C12.1771 16.2344 12.8334 16.1875 12.8334 16.1875Z"
                                                fill="#272D3C"
                                            />
                                        </svg>
                                    </div>

                                    <p className='frame20DocAdmini'>
                                        {name}
                                    </p>
                                </div>
                                <p className='frame020DocAdmini'>{i18n.t('Signé le')} {date} {i18n.t('à')} {heure} {i18n.t('par')} Aiman Fakia</p>
                                {/*<p className='frame020DocAdmini'>Signé le {formatDateJJMMYYYY(documentAdministratifs[0]?.createdAt)} à{' '} {getTimeFromIsoFormatDate(documentAdministratifs[0]?.createdAt)} par {getNomPrenomClearFromPersoData(documentAdministratifs[0]?.expertId?.persoData)}</p>          */}

                            </div>

                            <div className='frame21DocAdmini'>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_3794_59600)">
                                        <path
                                            d="M18.75 13.9375H16.8516L15.1641 15.625H18.75C19.0312 15.625 19.3125 15.9062 19.3125 16.1875V19C19.3125 19.3164 19.0312 19.5625 18.75 19.5625H5.25C4.93359 19.5625 4.6875 19.3164 4.6875 19V16.1875C4.6875 15.9062 4.93359 15.625 5.25 15.625H8.80078L7.11328 13.9375H5.25C3.98438 13.9375 3 14.957 3 16.1875V19C3 20.2656 3.98438 21.25 5.25 21.25H18.75C19.9805 21.25 21 20.2656 21 19V16.1875C21 14.957 19.9805 13.9375 18.75 13.9375ZM18.1875 17.5938C18.1875 17.1367 17.8008 16.75 17.3438 16.75C16.8516 16.75 16.5 17.1367 16.5 17.5938C16.5 18.0859 16.8516 18.4375 17.3438 18.4375C17.8008 18.4375 18.1875 18.0859 18.1875 17.5938ZM11.4023 16.2227C11.543 16.3984 11.7539 16.4688 12 16.4688C12.2109 16.4688 12.4219 16.3984 12.5625 16.2227L17.3438 11.4414C17.6953 11.125 17.6953 10.5977 17.3438 10.2812C17.0273 9.92969 16.5 9.92969 16.1836 10.2812L12.8438 13.6211V4.09375C12.8438 3.63672 12.457 3.25 12 3.25C11.5078 3.25 11.1562 3.63672 11.1562 4.09375V13.6211L7.78125 10.2461C7.42969 9.92969 6.90234 9.92969 6.58594 10.2461C6.23438 10.5977 6.23438 11.125 6.58594 11.4414L11.4023 16.2227Z"
                                            fill="#272D3C"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_3794_59600">
                                            <rect
                                                width="24"
                                                height="24"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                        </div>

                    </div>
                    <div className='frame22DocAdmini'>
                        <div className='frame0Contrat'>
                            <Button
                                variant="contained"
                                style={{...buttonStyles()}}
                                startIcon={<EditIcon />}
                            >
                                {i18n.t('Signer')}
                            </Button>
                        </div>

                        {/*</div>*/}
                    </div>
                </div>
            </div>

        </>
    );
}
export default DocumentsAdministratifsClient;